import Api from "@/services/Api";

export default {
  getShipmentData(params, callback, errCallback) {
    const authUser = JSON.parse(window.localStorage.getItem("userljrs"));

    if (params.filter) {
      params.filter += " AND (customerId = " + authUser.customerId + ")";
    } else {
      params.filter = "customerId = " + authUser.customerId;
    }

    return Api()
      .get("/LJRSS3Production/_table/shipment_view", {
        params: params,
        headers: {
          "x-dreamfactory-session-token": authUser.session_token
        }
      })
      .then(data => {
        callback(data);
      })
      .catch(error => {
        errCallback(error);
      });
  },
  getShipmentById(params, callback, errCallback) {
    const authUser = JSON.parse(window.localStorage.getItem("userljrs"));

    return Api()
      .get("/LJRSS3Production/_table/tentry", {
        params: params,
        headers: {
          "x-dreamfactory-session-token": authUser.session_token
        }
      })
      .then(data => {
        callback(data);
      })
      .catch(error => {
        errCallback(error);
      });
  }
};
